import { useCallback } from 'react';
import type { FlowId } from '../../types';
import { useWizardStore } from '../wizardStore';

interface FlowRestartOptions {
  flowId: FlowId;
  sessionId: string | null;
  completedFlowCache: Set<FlowId>;
  setHasCompletedFlow: (completed: boolean) => void;
}

export const useFlowRestart = ({
  flowId,
  sessionId,
  completedFlowCache,
  setHasCompletedFlow,
}: FlowRestartOptions) => {
  const handleRestart = useCallback(() => {
    if (typeof window !== 'undefined') {
      if (sessionId) {
        window.sessionStorage.removeItem(`wizardState:${sessionId}`);
        window.sessionStorage.removeItem(`wizardCompleted:${sessionId}`);
      } else {
        window.sessionStorage.clear();
      }

      window.sessionStorage.removeItem(`wizardCompleted:flow:${flowId}`);
    }

    completedFlowCache.delete(flowId);
    setHasCompletedFlow(false);

    // Reset wizard state including selfServiceData
    useWizardStore.setState({
      selfServiceData: {},
      hasCompletedFlow: false,
    });

    const newUrl = new URL(window.location.origin);
    newUrl.pathname = `/${flowId}`;
    window.location.href = newUrl.toString();
  }, [flowId, sessionId, setHasCompletedFlow, completedFlowCache]);

  return { handleRestart };
};
